module.exports = __webpack_public_path__ + "static/media/woosh.3aa5cc4f.mp3";